// src/theme.ts
import * as Colours from "@mui/material/colors"
import { createTheme, ThemeOptions } from '@mui/material/styles';
import {
  getHeaderColor,
  getPrimaryColour,
  getSecondaryColour,
} from "../services/whiteLabel";

declare module "@mui/material/styles" {
  interface Palette {
    header: Palette["primary"];
  }

  interface PaletteOptions {
    header?: PaletteOptions["primary"];
  }
}

const baseTheme: ThemeOptions = {
  palette: {
    mode: 'light', // default mode; will be overridden by system if needed
    primary: {
      main: '#1976d2',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      "Open Sans",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(",")
  }
  // Add other options if needed
};

function makePaletteColor(name: keyof typeof Colours) {
  if (name.startsWith("#")) {
    return { main: name };
  }
  const ramp = Colours[name] as Record<number, string>; // e.g., blue[500], blue[300], etc.
  return {
    main: ramp[500],
    light: ramp[300],
    dark: ramp[700],
  };
}

export const getTheme = (mode: 'light' | 'dark') =>
  createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none', // disables MUI's elevation overlay in dark mode
          },
        },
      },
    },
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      primary: makePaletteColor(getPrimaryColour()),
      secondary: makePaletteColor(getSecondaryColour()),
      header: {
        main: getHeaderColor(),
      },
      mode,
      ...(mode === 'dark'
        ? {
            background: {
              default: '#070F17',   // was #0F1923 — push it darker
              paper: '#0D1820',     // was #1A2530 — slightly darker, less grey/blue
            },
          }
        : {
          background: {
            default: "#e5e5e5",
            paper: "#f0f0f0",
          },
        }),
    },
  });
